import { Outlet } from "react-router-dom";
import CssBaseline from '@mui/material/CssBaseline';
import { noraWebTheme } from './noraWebTheme.js';
import NoraAppBar2 from './NoraAppBar2.tsx'
import NoraMenu from "./NoraMenu.js";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { useEffect } from "react";


export default function Main() {
    
  useEffect(() => {
    document.title = 'Nora Vest';
  }, []);

  return (
      <ThemeProvider theme={noraWebTheme}>
          <Box sx={{ display: 'block' ,bgcolor: 'background.paper',height:'100%',width:`100%`}}>
            <CssBaseline/>
            <NoraAppBar2/>
            <NoraMenu/>
            <Box
              component="main"
              sx={{flexGrow: 1, bgcolor: 'background.paper',height:'100%',width:`100%`}}
            >
              <Toolbar/>
              <Outlet/>
            </Box>
          </Box>
      </ThemeProvider>
  )
}
